import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useCallback } from 'react';
import ListItem from './list-item.esm.js';
import Checkbox from '../checkbox/checkbox.esm.js';

var _excluded = ["variant", "checked", "label"];
var StandardCheckListItem = function StandardCheckListItem(props) {
  var variant = props.variant,
    checked = props.checked,
    label = props.label,
    rest = _objectWithoutProperties(props, _excluded);
  var handleCheckBoxClick = useCallback(function (e) {
    return e.preventDefault();
  }, []);
  // eslint-disable-next-line no-console
  // console.log('--- render @costar/theme-ui StandardCheckListItem -----')
  return /*#__PURE__*/React.createElement(ListItem, _extends({
    height: "2em"
  }, rest), /*#__PURE__*/React.createElement(Checkbox, {
    variant: variant,
    checked: checked,
    label: label,
    onClick: handleCheckBoxClick
  }));
};
var standardCheckListItem = /*#__PURE__*/React.memo(StandardCheckListItem);

export default standardCheckListItem;
//# sourceMappingURL=standard-check-list-item.esm.js.map
